import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=d173d8ac&"
import script from "./AdminPage.vue?vue&type=script&lang=ts&"
export * from "./AdminPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d173d8ac')) {
      api.createRecord('d173d8ac', component.options)
    } else {
      api.reload('d173d8ac', component.options)
    }
    module.hot.accept("./AdminPage.vue?vue&type=template&id=d173d8ac&", function () {
      api.rerender('d173d8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Admin/AdminPage.vue"
export default component.exports